import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Redirect replit.app domain to the real domain (production only)
if (typeof window !== "undefined") {
  const host = window.location.hostname;
  if (host.endsWith(".replit.app")) {
    window.location.replace(
      "https://plomberieexcellence.com" +
        window.location.pathname +
        window.location.search +
        window.location.hash,
    );
  }
}

const rootEl = document.getElementById("root")!;
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Hydrate if SSR content is present (production prerender), otherwise mount fresh (dev)
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}
